import * as React from "react"

const Waves = () => (
    <div className="block-wave block--white">
        <div className="block__wave">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 60" preserveAspectRatio="none" style={{ position: 'relative', width: '100vw', maxHeight: '150px', transform: 'rotate(180deg)' }}>
                <path d="M 0 0 h 80 v 30 Q 60 0, 40 30 T 0 30 Z" fill="white" stroke="none"></path>
            </svg>
        </div>
    </div>
);

export default Waves;